// Telegram WebApp SDK wrapper. Use as enhancements behind feature detection (docs/MINIAPP.md §18.3).

interface TelegramUser {
  id: number;
  first_name: string;
  last_name?: string;
  username?: string;
  language_code?: string;
}

interface TelegramHaptic {
  impactOccurred: (style: 'light' | 'medium' | 'heavy' | 'soft' | 'rigid') => void;
  notificationOccurred: (type: 'success' | 'warning' | 'error') => void;
  selectionChanged: () => void;
}

interface TelegramWebApp {
  ready: () => void;
  expand: () => void;
  close: () => void;
  initData: string;
  initDataUnsafe?: { user?: TelegramUser };
  themeParams?: Record<string, string>;
  colorScheme?: 'light' | 'dark';
  HapticFeedback?: TelegramHaptic;
  showAlert?: (msg: string, cb?: () => void) => void;
  showConfirm?: (msg: string, cb: (ok: boolean) => void) => void;
}

declare global {
  interface Window {
    Telegram?: { WebApp?: TelegramWebApp };
  }
}

export const tg: TelegramWebApp | undefined =
  typeof window !== 'undefined' ? window.Telegram?.WebApp : undefined;

export function initTelegram() {
  if (!tg) return;
  try {
    tg.ready();
    tg.expand();
  } catch {
    /* noop — older Telegram clients may not support all APIs */
  }
}

export function haptic(kind: 'light' | 'medium' | 'heavy' | 'success' | 'warning' | 'error' = 'light') {
  const h = tg?.HapticFeedback;
  if (!h) return;
  try {
    if (kind === 'success' || kind === 'warning' || kind === 'error') {
      h.notificationOccurred(kind);
    } else {
      h.impactOccurred(kind);
    }
  } catch {
    /* noop */
  }
}

export function getTelegramUser(): TelegramUser | null {
  return tg?.initDataUnsafe?.user || null;
}
